// extracted by mini-css-extract-plugin
export var chevron = "_i5-3";
export var chevronRotated = "_i5-4";
export var image = "_i5-1";
export var imageContainer = "_i5-0";
export var shippingAddress = "_i5-2";